<section id="signup_sec" class="sec_sign_up">
   <a (click)="scroll('hcpsignupForm')"><img class="down_arrow_img" src="../../../assets/img/hcp_down_arrow.svg" /></a>
    <div class="content-container">
      <div class="sign_up_form" [hidden]="hcpsignUpForm">
        <h3>Follow the latest developments</h3>
        <p>Sign up to receive updates on a therapy addressing the top of the contact activation pathway. </p>
        <p class="required_msg">*Required fields </p>
        <form id="hcpsignupForm" [formGroup]="signupForm" (ngSubmit)="hcpsignup()">
          <div>
            <input formControlName="FRST_NM" placeholder="First Name*">
            <div *ngIf="signupForm.controls['FRST_NM'].invalid && (signupForm.controls['FRST_NM'].dirty ||  signupForm.controls['FRST_NM'].touched) " class="alert alert-danger">
              Please enter your first name.
            </div>  
          </div>
          <div>
            <input formControlName="LAST_NM" placeholder="Last Name*">
            <div *ngIf="signupForm.controls['LAST_NM'].invalid && (signupForm.controls['LAST_NM'].dirty || signupForm.controls['LAST_NM'].touched)" class="alert alert-danger">
              Please enter your last name.
            </div> 
          </div>
          <div>
            <input formControlName="email" placeholder="Email*">
            <div *ngIf="signupForm.controls['email'].invalid && (signupForm.controls['email'].dirty || signupForm.controls['email'].touched)" class="alert alert-danger">
              Please enter a valid email address.
          </div> 
            </div>
          <div class="zipcode">
            <input formControlName="ZIP5_CD" placeholder="Zip Code*">
            <div *ngIf="signupForm.controls['ZIP5_CD'].invalid && (signupForm.controls['ZIP5_CD'].dirty || signupForm.controls['ZIP5_CD'].touched)" class="alert alert-danger">
              Please enter a valid 5-digit ZIP Code.
            </div> 
          </div>
          <div class="npinumber">
            <input formControlName="NPI" placeholder="NPI Number">
            <div *ngIf="signupForm.controls['NPI'].invalid && (signupForm.controls['NPI'].dirty || signupForm.controls['NPI'].touched)" class="alert alert-danger">
              Please enter a NPI number.
            </div>
          </div>
          <div class="institute">
            <input formControlName="BUS_NM" placeholder="Institution">
            <div *ngIf="signupForm.controls['BUS_NM'].invalid && (signupForm.controls['BUS_NM'].dirty || signupForm.controls['BUS_NM'].touched)" class="alert alert-danger">
                Please enter the institution.
            </div> 
          </div>
          
          <button type="submit" [disabled]="this.disableButton">SIGN UP <img src="assets/img/hcp_signup_arrow.svg" target="_blank" ></button>
        </form>
      </div>
      <div class="thank_you_box" [hidden]="thankYouDiv" >
        <p>Thank you!</p>
        <p>We will send additional information as soon as it becomes available. </p>
        <div class="box">
          <p>Share this page with your colleagues</p>
          <a href="mailto:viraj.deshmukh@cslbehring.com?subject=Learn more about targeting activated factor XII&body=I thought you would be interested in news and educational materials on HAE and targeting activated factor XII. Check out: https://www.allabouthae.com/HCP.">Share</a>
        </div>
      </div>
    </div>
  </section>
